import {
  FaLanguage,
  FaChevronRight,
  FaPalette,
  FaRightFromBracket,
} from "react-icons/fa6";
import { FaTimesCircle, FaUser } from "react-icons/fa";

import Avatar from "../Avatar/Avatar";
import { useNavigate } from "react-router-dom";
import "./logoutdialogue.scss";
export default function LogOutDialogue({
  userData,
  showProfileDetails,
  setShowProfileDetails,
}) {
  console.log(
    "***********************************************************",
    userData
  );
  const navigate = useNavigate();
  const handleLogout = () => {
    // dispatch(logOutPartner({}));
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0].trim();
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });

    // Clear local storage
    localStorage.clear();

    // Optionally, clear session storage too
    sessionStorage.clear();

    navigate("/", { replace: true });
  };

  const handleShowProfileDetailsClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div
      className="logout-container container-background"
      onClick={() => {
        setShowProfileDetails(false);
      }}
    >
      <div
        className="show-more-profile-data"
        onClick={handleShowProfileDetailsClick}
      >
        <div className="logoutbox-header">
          <div className="profile-img-container">
            {/* {
              // !profileImg=="default-avatar.png"?
              userData?.profile_img ? (
                <img src={userData?.profile_img} alt="Profile" className="profileImg" />
              ) : ( */}
                <Avatar
                  name={userData ? userData.name : "Fetching..."}
                  fontSize="16px"
                  hover={"false"}
                  height={"60px"}
                  width={"60px"}
                />
           
          </div>
          <div className="logout-header-text">
            <h3>{userData ? userData.name : "Fetching..."}</h3>
            <p>{userData ? userData.email : "Fetching..."}</p>
          </div>
        </div>

        <ul className="logoutbox-options">
          <li
            className="logoutbox-options-items"
            onClick={() => {
              navigate("/dashboard/partner");
              setShowProfileDetails(false);
            }}
          >
            <p>
              {" "}
              <FaUser />
              Your Profile
            </p>
            <FaChevronRight />
          </li>

          <li className="logoutbox-options-items">
            <p>
              {" "}
              <FaPalette />
              Theme
            </p>
            <p className="comming-soon">Coming Soon</p>
          </li>

          <li className="logoutbox-options-items">
            <p>
              <FaLanguage />
              Language
            </p>
            <p className="comming-soon">Coming Soon</p>
          </li>
          <li
            className="logoutbox-options-items logout-user-btn"
            onClick={handleLogout}
          >
            {/* Icon */}
            <p>
              {" "}
              <FaRightFromBracket /> Logout
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
}
